import config from "../config";

export async function getOptimizationParameters(backendFetch, siteId) {
  const f = await backendFetch(config.REACT_APP_HOST + "/api/v2/parameters/" + siteId, {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  });
  return await f.json();
}
